import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EventEmitterService {
    emitEvent(eventName: string, data: any) {
        const event = new CustomEvent(eventName, {
            detail: data
        });

        document.dispatchEvent(event);
    }
}
